import React, { useState, useCallback } from "react";
import {
  Grid,
  Button,
  IconButton,
  Card,
  Collapse,
  CardHeader,
  LinearProgress,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from '@material-ui/icons/Add';
import actionsTopButtonStyles from '../../../../../components/App/customMaterialStyles';
import { datetimeToString } from "../../../../../../utils/datetime";
import LessonItem from "./LessonItem";
import LessonsService from "../../../../../../services/LessonsService";
import EmptyResult from "../../../../../components/EmptyResult";
import EditLessonModal from "./modals/modalLesson";


const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: "1em",
    "& .MuiCardHeader-action .MuiButton-text": {
      marginTop: "1em",
      marginRight: "1.5em"
    },
  },
  collapse: {
    borderTop: "1px solid #c8cccc"
  }
}));

function CourseLessonsItem(props) {
  const classes = useStyles();
  const actionsTopButtonStylesClasses = actionsTopButtonStyles();

  const { id, name, modified_datetime} = props.data || {};

  const { loading = false } = props;  
  const [expanded, setExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lessons, setLessons] = useState(false);
  
  // Modal
  const [openModalLessons, setOpenModalLessons] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [isEditModal, setIsEditModal] = useState(false);

  const fetchLessonsData = useCallback(async () => {
    setIsLoading(true);
    try{
      const result = await LessonsService.listLessons(id, {
        fields: 'id,name,start_date,end_date,modified_datetime,created_datetime',
        limit: 'no_paginate',
        ordering: 'created_datetime'
      });
      setLessons(result.data.results);      
      setIsLoading(false);
    }catch (error) {
      setLessons([]);
      setIsLoading(false);
    }  
  }, [id]) 

  const handleExpandClick = () => {
    if(!expanded){
      fetchLessonsData();
    }    
    setExpanded(!expanded);
  };

  const handleClickNewLesson = () => {
    setOpenModalLessons(true); 
    setIsEditModal(false);
  }

  return(
    <Card className={classes.root}>
      <CardHeader
        action={
          <React.Fragment >
            {loading ?
              <Skeleton
                variant="circle"
                width={50}
                height={50}
                style={{ marginBottom: 0 }}
              />
              :
              <React.Fragment >
                <Button
                  color="primary"
                  onClick={handleClickNewLesson}
                  endIcon={<AddIcon />}
                > Add new Module
                </Button>

                <IconButton
                  className={clsx(actionsTopButtonStylesClasses.expand, {
                    [actionsTopButtonStylesClasses.expandOpen]: expanded
                  }, actionsTopButtonStylesClasses.actionsTopButtons)}
                  onClick={handleExpandClick}
                  aria-expanded={expanded}
                  aria-label="Expand"
                  data-testid="expand-lesson"
                >
                  <ExpandMoreIcon />
                </IconButton>              
              </React.Fragment>
            }
          </React.Fragment>
        }
        title={
          loading ? (
            <Skeleton
              variant="rect"
              width={180}
              height={20}
              style={{ marginBottom: 6 }}
            />
          ) : (
            name
          )
        }
        subheader={
          loading ? (
            <Skeleton variant="rect" width={210} height={10} />            
          ) : (
            `Last edit: ${datetimeToString(modified_datetime, "MM-DD-YYYY HH:mm")}`
          )
        }
      />

      {/* Loading */}
      {isLoading ? 
        <LinearProgress />
      :
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="stretch">
              
            {lessons.length > 0 ?
                lessons.map(lesson => (
                  <LessonItem 
                    key={lesson.id}
                    data={lesson}  
                    courseId={id} 
                    setOpenModalLessons={setOpenModalLessons} 
                    setModalData={setModalData} 
                    setIsEditModal={setIsEditModal}
                    fetchLessonsData={fetchLessonsData}/>
                ))    
              :
                <EmptyResult className={classes.collapse} elevation={0}/> 
            }              
          </Grid>
        </Collapse>
      }

      {/* Modal Dialog for Remove Data */}
      <EditLessonModal
        open={openModalLessons}
        courseId={id}
        data={modalData}
        onClose={() => setOpenModalLessons(false)}
        updateList={fetchLessonsData}
        isEditModal={isEditModal}
      />

    </Card>
  )
}

export default CourseLessonsItem;